<script setup lang="ts">
import { cn } from "@shared/lib/utils";
import { ToastDescription, type ToastDescriptionProps } from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<ToastDescriptionProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <ToastDescription :class="cn('text-caption opacity-90', props.class)" v-bind="delegatedProps">
    <slot />
  </ToastDescription>
</template>
